module.exports = __webpack_public_path__ + "img/bluesky00.cb10d897.jpg";